// ریز درخواست کالا / خدمات
// props: { user, onBack, request }  — request: ردیف انتخاب‌شدهٔ درخواست (id, request_kind, request_no, request_date, …)
import React, { useState, useEffect, useCallback } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { ExcelButton } from '../../components/excel';
import { useFormButtons } from '../../utils/vbPerms';
import {
  API, toFa, toEng, num, fmtAmt, splitLines, visibleCols, MsgBox, AskBox, Field, DateField, SelectField, Box,
  Lookup, Grid, Modal, tbtn,
} from './RequestsShared';

const FORM = 'FRMGOODSREQUESTDETAIL';
const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNDELETEALL', 'BTNEDITALL', 'BTNHISTORY', 'BTNOK', 'BTNCANCEL'];
const TITLE = 'ریز درخواست کالا / خدمات';
const KINDS = ['خرید کالای مصرفی', 'خرید کالای اموالی', 'انجام خدمات', 'خرید کالای مصرفی تحویل مستقیم'];
const DEL_ALL = 'حذف گروهی اقلام';
const DEL_SEL = 'حذف اقلام انتخابی';

export const DETAIL_COLS = [
  { key: 'row', label: 'ردیف', num: true },
  { key: 'goods_code', label: 'کد کالا' },
  { key: 'request_kind_title', label: 'نوع درخواست' },
  { key: 'goods_name', label: 'شرح کالا/خدمات', wrap: true },
  { key: 'feature', label: 'ویژگی', wrap: true },
  { key: 'request_quantity', label: 'تعداد درخواستی', num: true },
  { key: 'quantity', label: 'تعداد', num: true },
  { key: 'unit', label: 'واحد' },
  { key: 'estimated_cost', label: 'برآورد مبلغ', money: true },
  { key: 'remark', label: 'شرح', wrap: true },
  { key: 'amount_receiver', label: 'فروشنده', wrap: true },
  { key: 'factor_no', label: 'فاکتور' },
  { key: 'factor_date', label: 'تاریخ' },
  { key: 'bought_quantity', label: 'تعدادخرید', num: true },
  { key: 'fee', label: 'مبلغ واحد', money: true },
  { key: 'sum_paid', label: 'جمع', money: true },
  { key: 'discount', label: 'تخفیف', money: true },
  { key: 'added_tax', label: 'مالیات بر ارزش افزوده', money: true },
  { key: 'total_pay', label: 'جمع کل', money: true },
  { key: 'factor_discount', label: 'تخفیف کلی فاکتور', money: true },
  { key: 'hazineh_document_no', label: 'شماره سند هزینه', num: true },
  { key: 'hazineh_document_date', label: 'تاریخ سند هزینه' },
  { key: 'stock_slip_no', label: 'شماره قبض انبار', num: true },
  { key: 'stock_slip_date', label: 'تاریخ قبض انبار' },
  { key: 'evaluation_finish_date', label: 'خاتمه رسیدگی' },
  { key: 'send_to_budget_date', label: 'ارسال به بودجه' },
  { key: 'havaleh', label: 'حواله', wrap: true },
];

const HIST_COLS = [
  { key: 'label_no', label: 'برچسب' }, { key: 'slip', label: 'قبض انبار/مجوز واگذاری' }, { key: 'date', label: 'تاریخ' },
  { key: 'price', label: 'قیمت', money: true }, { key: 'ag_kind', label: 'نوع انبارگردانی' },
  { key: 'ag_qty', label: 'تعداد انبارگردانی', num: true }, { key: 'buy_qty', label: 'تعداد خرید', num: true },
  { key: 'from_serial', label: 'از شماره سریال' }, { key: 'to_serial', label: 'تا شماره سریال' },
  { key: 'given_qty', label: 'تعداد واگذارشده', num: true }, { key: 'return_qty', label: 'تعداد مرجوعی', num: true },
  { key: 'stock', label: 'موجودی', num: true }, { key: 'receiver', label: 'دریافت کننده', wrap: true },
  { key: 'leave_date', label: 'تاریخ خروج' }, { key: 'send_letter_no', label: 'شماره نامه ارسال به خزانه' },
  { key: 'send_letter_date', label: 'تاریخ نامه ارسال به خزانه' }, { key: 'request_no', label: 'شماره درخواست' },
  { key: 'request_date', label: 'تاریخ درخواست' }, { key: 'asker', label: 'درخواست کننده', wrap: true },
  { key: 'asker_dept', label: 'واحد درخواست کننده', wrap: true }, { key: 'seller', label: 'فروشنده', wrap: true },
  { key: 'factor_no', label: 'شماره فاکتور' }, { key: 'factor_date', label: 'تاریخ فاکتور' },
  { key: 'stock_time', label: 'زمان تحویل انبار' }, { key: 'hazineh_no', label: 'شماره سند هزینه' },
  { key: 'hazineh_date', label: 'تاریخ سند هزینه' },
];

const KEYS = ['request_kind', 'row', 'goods_id', 'goods_name', 'feature_id', 'feature', 'request_quantity', 'quantity', 'unit',
  'estimated_cost', 'remark', 'amount_receiver_id', 'amount_receiver', 'factor_no', 'factor_date', 'bought_quantity', 'fee',
  'sum_paid', 'discount', 'factor_discount', 'added_tax', 'total_pay', 'hazineh_document_no', 'hazineh_document_date',
  'stock_slip_no', 'stock_slip_date'];
const ZERO = ['request_kind', 'goods_id', 'feature_id', 'amount_receiver_id'];
const pick = r => KEYS.reduce((o, k) => ({ ...o, [k]: r ? (r[k] ?? '') : (ZERO.includes(k) ? 0 : '') }), {});
const sumOf = rows => rows.reduce((a, r) => a + num(r.sum_paid) - num(r.discount) - num(r.factor_discount) + num(r.added_tax), 0);
const total = f => num(f.sum_paid) - num(f.discount) + num(f.added_tax);

function matches(r, s) {
  if (!s) return true;
  const n = Number(toEng(s).replace(/,/g, ''));
  const like = k => String(r[k] ?? '').includes(s);
  return like('remark') || like('goods_name') || like('amount_receiver') || like('factor_no')
    || (!isNaN(n) && (num(r.total_pay) === n || num(r.sum_paid) === n));
}

function EditAllDialog({ ea, setEa, onRun, onClose }) {
  const E = (k, v) => setEa(f => ({ ...f, [k]: v }));
  return (
    <Modal title="ویرایش گروهی اقلام" width="720px" onClose={onClose}
      footer={<button onClick={onRun} style={ui.btnSave}>اعمال تغییرات</button>}>
      <div style={ui.row}>
        <Box title="فعلی">
          <Field label="فاکتور" value={ea.fore_factor_no} onChange={v => E('fore_factor_no', v)} ltr />
          <DateField label="تاریخ" value={ea.fore_factor_date} onChange={v => E('fore_factor_date', v)} />
          <Field label="فروشنده/گیرنده وجه" value={ea.fore_amount_receiver} disabled flex={2} />
        </Box>
      </div>
      <div style={ui.row}>
        <Box title="جدید">
          <Field label="فاکتور" value={ea.new_factor_no} onChange={v => E('new_factor_no', v)} ltr />
          <DateField label="تاریخ" value={ea.new_factor_date} onChange={v => E('new_factor_date', v)} />
          <Lookup label="فروشنده/گیرنده وجه" value={ea.new_amount_receiver} endpoint="/detail/lookup/amount-receivers/" flex={2}
            onPick={r => setEa(f => ({ ...f, new_amount_receiver_id: r.id, new_amount_receiver: r.title }))} />
        </Box>
      </div>
      <div style={ui.row}>
        <Field label="شرح" value={ea.new_remark} onChange={v => E('new_remark', v)} flex={4} />
      </div>
    </Modal>
  );
}

export default function GoodsRequestDetail({ user, onBack, request }) {
  const fb = useFormButtons(FORM, BUTTONS);
  const gid = request && request.id;
  const [rows, setRows] = useState([]);
  const [head, setHead] = useState(null);
  const [kind, setKind] = useState(Number(request && request.request_kind) || 0);
  const [mustExist, setMustExist] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState('');
  const [mode, setMode] = useState('normal');
  const [form, setForm] = useState(pick(null));
  const [goodsLocked, setGoodsLocked] = useState(false);
  const [goodsPinned, setGoodsPinned] = useState(false);
  const [taxPct, setTaxPct] = useState(0);
  const [remarkHint, setRemarkHint] = useState(false);
  const [saving, setSaving] = useState(false);
  const [delMode, setDelMode] = useState(false);
  const [checked, setChecked] = useState(new Set());
  const [ea, setEa] = useState(null);
  const [hist, setHist] = useState(null);
  const [msg, setMsg] = useState(null);
  const [ask, setAsk] = useState(null);

  const showMsg = m => setMsg(splitLines(m || 'خطای داخلی سرور'));
  const errOf = j => j.msg || j.detail || j.error || 'خطای داخلی سرور';

  const load = useCallback((keepId) => {
    if (!gid) return;
    setLoading(true);
    API(`/detail/${gid}/`).then(j => {
      setLoading(false);
      if (!j.ok) { setError(errOf(j)); return; }
      setError('');
      const data = j.data || [];
      setRows(data); setHead(j.head || null);
      setKind(Number(j.request_kind) || 0); setMustExist(!!j.must_exist);
      setSelected(prev => {
        const id = keepId || (prev && prev.id);
        return (id && data.find(r => r.id === id)) || data[0] || null;
      });
    });
  }, [gid]);

  useEffect(() => { if (fb.loaded && fb.open) load(); }, [fb.loaded, fb.open, load]);
  useEffect(() => { if (mode === 'normal') setForm(pick(selected)); }, [selected, mode]);

  const editing = mode !== 'normal';
  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const isProperty = kind === 1 || (kind === 4 && Number(form.request_kind) === 1);
  const shown = rows.filter(r => matches(r, search.trim()));
  const cols = visibleCols(DETAIL_COLS, rows);
  const has = !!selected;

  // جمع کل درخواست و جمع فاکتور ردیف جاری
  const sumRequest = sumOf(rows);
  const sameFactor = selected ? rows.filter(r => r.factor_no === selected.factor_no && r.factor_date === selected.factor_date) : [];
  const sumFactor = sumOf(sameFactor);
  const hideFactorDiscount = !editing && selected && num(selected.factor_discount) === 0
    && sameFactor.reduce((a, r) => a + num(r.factor_discount), 0) > 0;

  // ───── جدید / ویرایش ─────
  const openNew = () => {
    setForm(f => {
      const keep = goodsPinned ? { goods_id: f.goods_id, goods_name: f.goods_name } : {};
      return { ...pick(null), request_kind: f.request_kind || 0, unit: f.unit, amount_receiver_id: f.amount_receiver_id,
        amount_receiver: f.amount_receiver, factor_no: f.factor_no, factor_date: f.factor_date, ...keep };
    });
    setGoodsLocked(false); setTaxPct(0); setMode('new');
    if (goodsPinned && form.goods_id) fetchTax(form.goods_id);
  };
  const openEdit = async () => {
    if (!selected) return;
    const j = await API(`/detail/item/${selected.id}/check-edit/`);
    if (!j.ok) { showMsg(errOf(j)); return; }
    setForm(pick(selected)); setGoodsLocked(!!j.goods_locked); setTaxPct(0); setMode('edit');
  };
  const cancel = () => { setMode('normal'); setForm(pick(selected)); };

  const fetchTax = (goodsId) => {
    API(`/detail/tax-percent/?goods_id=${goodsId}`).then(j => setTaxPct(j.ok ? Number(j.percent) || 0 : 0));
  };

  const save = async (confirmed = []) => {
    setSaving(true);
    const body = JSON.stringify({ ...form, confirmed });
    const j = mode === 'new'
      ? await API(`/detail/${gid}/create/`, { method: 'POST', body })
      : await API(`/detail/item/${selected.id}/update/`, { method: 'PUT', body });
    setSaving(false);
    if (!j.ok) {
      if (j.confirm) {
        setAsk({ lines: j.lines, onYes: () => { setAsk(null); save([...confirmed, j.confirm]); } });
      } else showMsg(errOf(j));
      return;
    }
    setMode('normal'); load(j.id);
  };

  // ───── حذف ─────
  const doDelete = async () => {
    setAsk(null);
    const j = await API(`/detail/item/${selected.id}/delete/`, { method: 'DELETE' });
    if (!j.ok) { showMsg(errOf(j)); return; }
    load();
  };
  const askDelete = async () => {
    if (!selected) return;
    setAsk({ lines: ['آيا از حذف اين رکورد مطمئن هستيد؟'], danger: true, onYes: doDelete });
  };
  const deleteAll = async () => {
    if (!delMode) { setDelMode(true); setChecked(new Set()); return; }
    const ids = [...checked];
    setDelMode(false); setChecked(new Set());
    if (!ids.length) { showMsg('هیچ آرتیکلی انتخاب نشده است'); return; }
    const j = await API(`/detail/${gid}/delete-all/`, { method: 'POST', body: JSON.stringify({ ids }) });
    if (!j.ok) { showMsg(errOf(j)); return; }
    load();
    const m = [...new Set(j.messages || [])];
    if (m.length) setMsg(m);
  };
  const toggleCheck = r => setChecked(s => {
    const n = new Set(s);
    if (n.has(r.id)) n.delete(r.id); else n.add(r.id);
    return n;
  });

  // ───── ویرایش گروهی ─────
  const openEditAll = () => {
    if (!rows.length || !selected) return;
    setEa({
      fore_factor_no: selected.factor_no || '', new_factor_no: selected.factor_no || '',
      fore_factor_date: selected.factor_date || '', new_factor_date: selected.factor_date || '',
      new_remark: selected.remark || '', fore_amount_receiver: selected.amount_receiver || '',
      amount_receiver_id: selected.amount_receiver_id || 0, new_amount_receiver_id: 0, new_amount_receiver: '',
    });
  };
  const runEditAll = async () => {
    const j = await API(`/detail/${gid}/edit-all/`, { method: 'POST', body: JSON.stringify(ea) });
    setEa(null);
    if (!j.ok) { showMsg(errOf(j)); return; }
    if (j.done) load();
  };

  // ───── سابقه ─────
  const openHistory = async () => {
    if (!form.goods_id) return;
    const j = await API(`/detail/history/?goods_id=${form.goods_id}`);
    if (!j.ok) { showMsg(errOf(j)); return; }
    if ((j.data || []).length) setHist(j.data);
  };

  // ───── رفتار فیلدها ─────
  const goodsPick = r => {
    setForm(f => ({ ...f, goods_id: r.id, goods_name: r.title, ...(r.id ? {} : { feature_id: 0, feature: '' }) }));
    if (mode === 'new' && r.id) fetchTax(r.id);
  };
  const goodsLeave = async (text, found) => {
    if (form.goods_id) return;
    if (/^\d+$/.test(toEng(text))) {
      const j = await API(`/detail/goods-by-code/?code=${encodeURIComponent(toEng(text))}`);
      if (j.ok && j.id) { goodsPick({ id: j.id, title: j.title }); return; }
    }
    if (found) return;
    if (mustExist) {
      setMsg(['این کالا قبلا معرفی نشده است', '', 'چون نوع درخواست، خرید کالای اموالی است، باید از کالاهای اموالی موجود انتخاب کنید']);
      return;
    }
    setAsk({
      lines: ['این کالا قبلا معرفی نشده است', 'آيا به فهرست کالاها اضافه شود؟'],
      onYes: async () => {
        setAsk(null);
        const j = await API('/detail/goods/create/', { method: 'POST', body: JSON.stringify({ name: text }) });
        if (j.ok) goodsPick({ id: j.id, title: j.title }); else showMsg('خطا در اضافه کردن کالا به فهرست کالاها');
      },
    });
  };
  const featureLeave = (text, found) => {
    if (form.feature_id || found || !form.goods_id) return;
    setAsk({
      lines: ['این ویژگی قبلا معرفی نشده است', 'آيا به فهرست ویژگی های این کالا اضافه شود؟'],
      onYes: async () => {
        setAsk(null);
        const j = await API('/detail/features/create/', { method: 'POST', body: JSON.stringify({ goods_id: form.goods_id, title: text }) });
        if (j.ok) setForm(f => ({ ...f, feature_id: j.id, feature: j.title }));
        else showMsg('خطا در اضافه کردن کالا به فهرست کالاها');
      },
    });
  };
  const receiverPick = r => setForm(f => ({ ...f, amount_receiver_id: r.id, amount_receiver: r.title,
    ...(r.id ? {} : { factor_no: '', factor_date: '' }) }));
  const factorFocus = async () => {
    if (!editing || num(form.factor_no) !== 0 || !form.amount_receiver_id) return;
    const j = await API(`/detail/last-factor/?amount_receiver_id=${form.amount_receiver_id}`);
    if (j.ok) setForm(f => ({ ...f, factor_no: j.factor_no, factor_date: j.factor_date }));
  };
  const setMoney = (k, v) => setForm(f => {
    const n = { ...f, [k]: v };
    if (k === 'sum_paid' && mode === 'new' && taxPct) n.added_tax = Math.round(num(v) * taxPct / 100);
    n.total_pay = total(n);
    return n;
  });
  const taxKey = e => {
    if (e.key !== 'F11' || !editing) return;
    e.preventDefault();
    setForm(f => { const n = { ...f, added_tax: (num(f.sum_paid) - num(f.discount)) * num(f.added_tax) / 100 }; n.total_pay = total(n); return n; });
  };
  const requestQtyLeave = () => { if (editing) setForm(f => (num(f.quantity) === 0 ? { ...f, quantity: f.request_quantity } : f)); };
  const boughtFocus = () => { if (editing) setForm(f => (num(f.bought_quantity) === 0 ? { ...f, bought_quantity: f.quantity } : f)); };
  const estimateLeave = () => {
    if (!editing) return;
    setForm(f => {
      if (num(f.fee) !== 0) return f;
      const n = { ...f, fee: f.estimated_cost, sum_paid: num(f.bought_quantity) * num(f.estimated_cost) };
      n.total_pay = total(n);
      return n;
    });
  };
  const feeFocus = () => { if (editing) setForm(f => (num(f.fee) === 0 ? { ...f, fee: f.estimated_cost } : f)); };
  const feeLeave = () => {
    if (!editing) return;
    setForm(f => {
      if (num(f.sum_paid) !== 0) return f;
      const n = { ...f, sum_paid: num(f.bought_quantity) * num(f.fee) };
      n.total_pay = total(n);
      return n;
    });
  };

  const gridKey = e => {
    if (editing || delMode) return;
    if ((e.key === 'Insert' || e.key === '+') && fb.can('BTNNEW')) { e.preventDefault(); openNew(); }
    else if (e.key === 'F4' && fb.can('BTNEDIT')) { e.preventDefault(); openEdit(); }
    else if (e.key === 'Delete' && fb.can('BTNDELETE')) { e.preventDefault(); askDelete(); }
  };

  const ro = !editing;
  const roGoods = ro || goodsLocked;
  const hzNo = num(form.hazineh_document_no);
  const ssNo = num(form.stock_slip_no);
  const subtitle = head ? `درخواست ${toFa(head.request_no)} — ${toFa(head.request_date)}` : 'تدارکات — سامانه ارجان';

  const toolbar = (
    <>
      {fb.open && !editing && (
        <div style={{ ...ui.toolBtns, flexWrap: 'wrap' }}>
          {fb.can('BTNNEW') && <button onClick={openNew} style={tbtn(ui.btnNew)}>＋ جدید</button>}
          {fb.can('BTNEDIT') && <button onClick={openEdit} disabled={!has} style={tbtn(ui.btnEdit, has)}>✎ ویرایش</button>}
          {fb.can('BTNDELETE') && <button onClick={askDelete} disabled={!has} style={tbtn(ui.btnDel, has)}>✕ حذف</button>}
          {fb.can('BTNDELETEALL') && (
            <button onClick={deleteAll} disabled={!rows.length} style={tbtn({ ...ui.btnDel, ...(delMode ? { background: '#fff', color: '#c62828', border: '2px solid #c62828' } : {}) }, rows.length > 0)}>
              {delMode ? DEL_SEL : DEL_ALL}
            </button>
          )}
          {fb.can('BTNEDITALL') && <button onClick={openEditAll} disabled={!has} style={tbtn(ui.btnItems, has)}>ویرایش گروهی اقلام</button>}
          {fb.can('BTNHISTORY') && <button onClick={openHistory} disabled={!form.goods_id} style={tbtn(ui.btnItems, !!form.goods_id)}>سابقه</button>}
        </div>
      )}
      {fb.open && editing && (
        <div style={ui.toolBtns}>
          {fb.can('BTNOK') && fb.can(mode === 'new' ? 'BTNNEW' : 'BTNEDIT') && (
            <button onClick={() => save([])} disabled={saving} style={tbtn(ui.btnSave)}>{saving ? '⏳' : 'ثبت'}</button>)}
          {fb.can('BTNCANCEL') && <button onClick={cancel} style={tbtn(ui.btnCancel)}>لغو</button>}
        </div>
      )}
      <input value={search} onChange={e => setSearch(e.target.value.replace(/\*/g, ''))} disabled={editing}
        style={{ ...ui.searchInput, flex: 1, minWidth: '160px' }} placeholder="جستجو" />
      <ExcelButton title={TITLE} subtitle={subtitle} columns={cols} rows={shown} />
    </>
  );

  return (
    <>
      <ListPage user={user} onBack={onBack} title={TITLE} subtitle={subtitle} toolbar={toolbar} error={error} loading={loading}>
        {fb.open && (
          <div style={ui.splitWrap}>
            <div style={{ ...ui.topPane, flex: '0 0 auto', maxHeight: '52%', padding: '8px 4px' }}>
              <div style={ui.row}>
                {kind === 4 && (
                  <SelectField label="نوع درخواست" value={Number(form.request_kind) || 0} options={KINDS} disabled={ro}
                    onChange={v => F('request_kind', v)} />
                )}
                <Field label="ردیف" value={form.row} onChange={v => F('row', v)} disabled={ro} ltr minWidth="60px" flex={0.4} />
                <Lookup label="کالا/خدمات" value={form.goods_name} disabled={roGoods} flex={3}
                  endpoint={`/detail/lookup/goods/${isProperty ? '?property=1' : ''}`} onPick={goodsPick} onLeave={goodsLeave} />
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <button type="button" onClick={() => setGoodsPinned(p => !p)}
                    title={goodsPinned ? 'کالا برای ردیف بعدی حفظ می‌شود' : 'حفظ کالا برای ردیف بعدی'}
                    style={{ ...ui.btnCancel, padding: '8px 10px', background: goodsPinned ? '#fff3cd' : undefined }}>📌</button>
                </div>
                <Lookup label="ویژگی" value={form.feature} disabled={ro || !form.goods_id} flex={2}
                  endpoint={`/detail/lookup/features/?goods_id=${form.goods_id || 0}`}
                  onPick={r => setForm(f => ({ ...f, feature_id: r.id, feature: r.title }))} onLeave={featureLeave} />
              </div>
              <div style={ui.row}>
                <Field label="تعداد: درخواست" value={form.request_quantity} onChange={v => F('request_quantity', v)}
                  onBlur={requestQtyLeave} disabled={roGoods} ltr />
                <Field label="تایید شده" value={form.quantity} onChange={v => F('quantity', v)} disabled={roGoods} ltr />
                <Lookup label="واحد" value={form.unit} endpoint="/detail/lookup/units/" disabled={ro}
                  onPick={r => F('unit', r.title)} onLeave={t => F('unit', t)} minWidth="110px" />
                <Field label="مبلغ برآورد" value={form.estimated_cost} onChange={v => F('estimated_cost', v)}
                  onBlur={estimateLeave} disabled={ro} ltr />
                <Field label="شرح" value={form.remark} onChange={v => F('remark', v)} disabled={ro} flex={3}
                  onFocus={() => setRemarkHint(true)} onBlur={() => setRemarkHint(false)}
                  hint="برای انتقال ادامه توضیحات به سطر بعد از $$$ استفاده کنید" />
              </div>
              {remarkHint && editing && (
                <div style={{ fontSize: '11px', color: '#b26a00', margin: '-4px 4px 6px' }}>برای انتقال ادامه توضیحات به سطر بعد از $$$ استفاده کنید</div>
              )}
              <div style={ui.row}>
                <Box title="اطلاعات خرید">
                  <Lookup label="فروشنده/گیرنده وجه" value={form.amount_receiver} endpoint="/detail/lookup/amount-receivers/"
                    disabled={ro} onPick={receiverPick} flex={2} minWidth="200px" />
                  <Field label="فاکتور" value={form.factor_no} onChange={v => F('factor_no', v)} onFocus={factorFocus} disabled={ro} ltr />
                  <DateField label="تاریخ" value={form.factor_date} onChange={v => F('factor_date', v)} disabled={ro} />
                  <Field label="تعداد" value={form.bought_quantity} onChange={v => F('bought_quantity', v)} onFocus={boughtFocus} disabled={ro} ltr minWidth="70px" />
                  <Field label="فی" value={form.fee} onChange={v => F('fee', v)} onFocus={feeFocus} onBlur={feeLeave} disabled={ro} ltr />
                  <Field label="مبلغ" value={form.sum_paid} onChange={v => setMoney('sum_paid', v)} disabled={ro} ltr />
                  <Field label="تخفیف" value={form.discount} onChange={v => setMoney('discount', v)} disabled={ro} ltr />
                  <Field label="م بر ارزش افزوده" value={form.added_tax} onChange={v => setMoney('added_tax', v)} onKeyDown={taxKey} disabled={ro} ltr />
                  {!hideFactorDiscount && (
                    <Field label="تخفیف کلی فاکتور" value={form.factor_discount} onChange={v => F('factor_discount', v)} disabled={ro} ltr />)}
                  <Field label="جمع" value={fmtAmt(total(form))} disabled ltr />
                </Box>
              </div>
              <div style={ui.row}>
                {hzNo > 0 && <Field label="سندهزینه" value={toFa(form.hazineh_document_no)} disabled minWidth="90px" />}
                {hzNo > 0 && <Field label="تاریخ" value={toFa(form.hazineh_document_date)} disabled minWidth="100px" />}
                {ssNo > 0 && <Field label="قبض انبار" value={toFa(form.stock_slip_no)} disabled minWidth="90px" />}
                {ssNo > 0 && <Field label="تاریخ" value={toFa(form.stock_slip_date)} disabled minWidth="100px" />}
                <Field label="جمع: فاکتور" value={fmtAmt(sumFactor)} disabled ltr />
                <Field label="کل" value={fmtAmt(sumRequest)} disabled ltr />
              </div>
            </div>
            <div style={{ ...ui.bottomPane, outline: 'none' }} tabIndex={0} onKeyDown={gridKey}>
              <Grid columns={cols} rows={shown} selectedId={selected && selected.id} loading={loading} zebra="#fdf6ec"
                onSelect={r => { if (!editing) setSelected(r); }}
                checked={delMode ? checked : null} onCheck={toggleCheck} empty="ردیفی ثبت نشده است" />
            </div>
          </div>
        )}
      </ListPage>

      {ea && <EditAllDialog ea={ea} setEa={setEa} onRun={runEditAll} onClose={() => setEa(null)} />}
      {hist && (
        <Modal title="سابقه کالا" width="1200px" onClose={() => setHist(null)}>
          <div style={{ maxHeight: '65vh', overflow: 'auto' }}>
            <Grid columns={visibleCols(HIST_COLS, hist)} rows={hist} />
          </div>
        </Modal>
      )}
      {ask && <AskBox title={ask.title} lines={ask.lines} danger={ask.danger} onYes={ask.onYes} onNo={ask.onNo || (() => setAsk(null))} />}
      {msg && <MsgBox lines={msg} onClose={() => setMsg(null)} />}
    </>
  );
}
